import { Box, Flex, styled, StyleSystemProps } from '@withjoy/joykit';
import { animationTransition } from '@shared/utils/animationTransition';
import { CSSObject } from '@withjoy/joykit/components/Box/Box.types';

export const StyledContainer = styled(Box)``;
export const StyledContent = styled(Flex)``;
export const StyledMediaContainer = styled(Box)``;
export const StyledGradient = styled(Box)``;
export const StyledBackgroundVideo = styled(Box)``;
export const StyledBackgroundVideoContainer = styled(Box)``;
export const StyledBackgroundImage = styled(Box)``;
export const StyledBlockText = styled(Flex)``;
export const StyledEyebrow = styled(Box)``;
export const StyledHed = styled(Box)``;
export const StyledDek = styled(Box)``;
export const StyledButtonsContainer = styled(Box)``;

export const StyledDekMobile = styled(Box)<{ isDescriptionShown?: boolean | false }>`
  margin-bottom: 8px;
  height: ${({ isDescriptionShown }) => (isDescriptionShown ? 'fit-content' : '45px')};
  overflow: hidden;
  position: relative;
  text-overflow: ellipsis;
  white-space: normal;
  max-width: 342px;
  display: ${({ isDescriptionShown }) => (isDescriptionShown ? 'block' : '-webkit-box')};
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const StyledReadMoreButton = styled(Box)<{ isDescriptionShown?: boolean | false }>`
  color: white;
  font-size: 16px;
  line-height: 24px;
  font-weight: ${({ isDescriptionShown }) => (isDescriptionShown ? 'medium' : 'regular')};
  width: fit-content;
  transition: animationTransition('color');
`;

const containerStyles: StyleSystemProps = {
  width: '100%',
  zIndex: 0,
  position: 'relative',
  backgroundColor: 'rgb(0,0,0)',
};

const contentStyles: StyleSystemProps = {
  width: '100vw',
  height: [
    `calc(80vh - var(--mobile-public-shop-navbar-height, 0px) - var(--mobile-admin-shop-navbar-height, 0px))`,
    null,
    `calc(60vh - var(--mobile-public-shop-navbar-height, 0px) - var(--mobile-admin-shop-navbar-height, 0px))`,
    '42vw',
  ],
  minHeight: '410px',
  paddingBottom: ['40px', null, '80px'],
  position: 'relative',
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  flexDirection: 'column',
  textAlign: 'center',
  zIndex: 1,
};

const mediaContainerStyles: StyleSystemProps = {
  height: '100%',
  position: 'absolute',
  top: '0px',
  left: '0px',
  right: '0px',
  zIndex: 1,
};

const mediaLayerStyles: StyleSystemProps = {
  ...mediaContainerStyles,
  height: '100%',
  width: '100%',
};

const gradientStyles: StyleSystemProps = {
  ...mediaLayerStyles,
  zIndex: 2,
  backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0) 41.74%, rgba(0, 0, 0, 0.45) 92.71%, rgba(0, 0, 0, 0.6) 100%), linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.4) 68.69%, rgba(0, 0, 0, 0.5) 100%)`,
};

const backgroundVideoStyles: StyleSystemProps = {
  ...mediaLayerStyles,
  zIndex: 1,
};

const backgroundVideoContainerStyles: CSSObject = {
  position: 'relative',
  height: '100%',
  overflow: 'hidden',
  padding: '0',
  ['& iframe']: {
    height: '56.25vw',
    left: '50%',
    minHeight: '100%',
    minWidth: '100%',
    transform: 'translate(-50%, -50%)',
    position: 'absolute',
    top: '50%',
    width: '177.77777778vh',
  },
};

const backgroundImageStyles = ($backgroundImageUrl: Maybe<string>): StyleSystemProps => ({
  ...mediaLayerStyles,
  zIndex: 1,
  backgroundImage: `url("${$backgroundImageUrl || ''}")`,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  backgroundSize: 'cover',
});

const blockTextStyles: StyleSystemProps = {
  alignItems: 'center',
  flexDirection: 'column',
  zIndex: 3,
};

const eyebrowStyles: StyleSystemProps = {
  color: 'white',
  fontWeight: ['semibold', null, 'semibold'],
  marginBottom: 0,
  typographyVariant: {
    _: 'hed2',
    sm2: 'hed4',
    md3: 'hed5',
    lg: 'hed6',
    xl: 'display1',
  },
};

const hedStyles: StyleSystemProps = {
  color: 'white',
  fontWeight: ['light', null, 'light'],
  maxWidth: '995px',
  transition: animationTransition('color'),
  marginX: 6,
  typographyVariant: {
    _: 'HedMobile32',
    sm2: 'Hed56',
    lg: 'HedHero72',
    xl: 'HedBreak96',
  },
};

const dekStyles: StyleSystemProps = {
  color: 'white',
  fontFamily: 'Inter UI',
  fontSize: ['16px', null, '20px'],
  fontWeight: ['regular', null, 'regular'],
  width: ['100%', null, '738px'],
  maxWidth: '738px',
  transition: animationTransition('color'),
  typographyVariant: {
    _: 'body1',
    sm2: 'body2',
    lg: 'body3',
  },
};

const buttonsContainerStyles: CSSObject = {
  transition: animationTransition('color'),
  maxWidth: '100%',
  typeVariant: ['body1', null, 'Dek20', null, 'Dek24'],
  width: ['100%', null, '552px', '648px'],
  padding: '20px 0px 10px 0px',
  zIndex: 3,
  ['& button']: {
    color: 'white',
    margin: 3,
    _hover: {
      color: 'white',
      borderColor: 'white',
      backgroundColor: 'rgba(255, 255, 255, 0.2)',
    },
  },
};

export const styles = {
  container: containerStyles,
  content: contentStyles,
  mediaContainer: mediaContainerStyles,
  gradient: gradientStyles,
  backgroundVideo: backgroundVideoStyles,
  backgroundVideoContainer: backgroundVideoContainerStyles,
  backgroundImage: backgroundImageStyles,
  blockText: blockTextStyles,
  eyebrow: eyebrowStyles,
  hed: hedStyles,
  dek: dekStyles,
  buttonsContainer: buttonsContainerStyles,
};
